import request from '@/utils/request';

export function getLoginWeChatUrl(params) {
  return request({
    url: '/User/getLoginWeChatUrl',
    params,
  });
}

export function login(username, password, agency) {
  return request({
    url: '/User/login',
    method: 'POST',
    data: {
      username,
      password,
      agency,
    },
  });
}

export function getUserBindMobileInfo(wechat) {
  return request({
    url: '/User/bindMobile',
    params: {
      wechat,
    },
  });
}

export function bindMobile(mobile, smsCode, wechat) {
  return request({
    url: '/User/bindMobile',
    method: 'POST',
    data: {
      mobile,
      sms_code: smsCode,
      wechat,
    },
  });
}

export function register(mobile, smsCode, password, passwordCheck) {
  return request({
    url: '/User/register',
    method: 'POST',
    data: {
      mobile,
      sms_code: smsCode,
      password,
      passwordCheck,
    },
  });
}

export function sendSmsCode(phone, type, geetestData) {
  let data = { mobile: phone, type };
  if (geetestData) data = { ...data, ...geetestData };
  return request({
    url: '/User/sendSmsCode',
    method: 'POST',
    data,
  });
}

export function verifyMobile(mobile, smsCode, type) {
  return request({
    url: '/User/verifyMobile',
    method: 'POST',
    data: {
      mobile,
      sms_code: smsCode,
      type,
    },
  });
}

export function resetPassword(data) {
  return request({
    url: '/User/resetPassword',
    method: 'POST',
    data,
  });
}

export function modifyPassword(oldPassword, newPassword, passwordCheck) {
  return request({
    url: '/User/modifyPassword',
    method: 'POST',
    data: {
      oldPassword,
      newPassword,
      passwordCheck,
    },
  });
}

export function logout() {
  return request({
    url: '/User/logout',
    method: 'POST',
  });
}

export function wechatRegister() {
  return request({
    url: '/User/wechatRegister',
    method: 'POST',
  });
}

export function getMyInfo() {
  return request({
    url: '/My/info',
    silentRequest: true,
  });
}

export function getMyAudio(params, silentRequest = false) {
  return request({
    url: '/My/audioList',
    params,
    silentRequest,
  });
}

export function getMyGiveRecord(params, silentRequest = false) {
  return request({
    url: '/My/giveRecord',
    params,
    silentRequest,
  });
}

export function getMyDetailInfo() {
  return request({
    url: '/My/detailInfo',
  });
}

export function getSchoolInfo(provinceCode, cityCode, areaCode, type) {
  return request({
    url: '/My/getSchools',
    method: 'POST',
    data: {
      provinceCode,
      cityCode,
      areaCode,
      type,
    },
  });
}

export function setMySignature(signature) {
  return request({
    url: '/My/commitSignature',
    method: 'POST',
    data: {
      signature,
    },
  });
}

export function setMyBirthday(birthday) {
  return request({
    url: '/My/commitBirthday',
    method: 'POST',
    data: {
      birthday,
    },
  });
}

export function getMyDefaultSchool() {
  return request({
    url: '/My/getDefaultSchoolInfo',
  });
}

export function setMySchool(id, provinceCode, cityCode, areaCode, type) {
  return request({
    url: '/My/commitSchool',
    method: 'POST',
    data: {
      id,
      provinceCode,
      cityCode,
      areaCode,
      type,
    },
  });
}

export function getGradeList() {
  return request({
    url: '/My/getGradeList',
  });
}

export function setMyGrade(id) {
  return request({
    url: '/My/commitGrade',
    method: 'POST',
    data: {
      id,
    },
  });
}

export function setMyGender(gender) {
  return request({
    url: '/My/commitGender',
    method: 'POST',
    data: {
      gender,
    },
  });
}

export function setMyNickName(nickName) {
  return request({
    url: '/My/commitNickName',
    method: 'POST',
    data: {
      nickName,
    },
  });
}

export function setMyEnglishName(enName) {
  return request({
    url: '/My/commitEnName',
    method: 'POST',
    data: {
      enName,
    },
  });
}

export function setMyTrueName(trueName) {
  return request({
    url: '/My/commitTrueName',
    method: 'POST',
    data: {
      trueName,
    },
  });
}

export function setMyParentName(parentName) {
  return request({
    url: '/My/commitParentName',
    method: 'POST',
    data: {
      parentName,
    },
  });
}

export function setMyEmail(email) {
  return request({
    url: '/My/commitEmail',
    method: 'POST',
    data: {
      email,
    },
  });
}

export function setMyAvatar(uri) {
  return request({
    url: '/My/setAvatar',
    method: 'POST',
    data: {
      uri,
    },
  });
}

export function getMyAddressList() {
  return request({
    url: '/My/getAddressList',
  });
}

export function deleteAddress(id) {
  return request({
    url: '/My/deleteAddress',
    method: 'POST',
    data: {
      id,
    },
  });
}

export function addMyAddress(params) {
  return request({
    url: '/My/commitAddress',
    method: 'POST',
    params,
  });
}

export function getMyAddressInfo(id) {
  return request({
    url: '/My/getAddress',
    params: { id },
  });
}

export function editMyAddress(params) {
  return request({
    url: '/My/editAddress',
    method: 'POST',
    params,
  });
}

export function getMyAccountInfo() {
  return request({
    url: '/My/accountInfo',
  });
}

export function modifyMobileByPassword(password, mobile, smsCode) {
  return request({
    url: '/My/modifyMobileByPassword',
    method: 'POST',
    data: {
      password,
      mobile,
      sms_code: smsCode,
    },
  });
}

export function modifyMobileBySMS(mobile, smsCode) {
  return request({
    url: '/My/modifyMobileBySMS',
    method: 'POST',
    data: {
      mobile,
      sms_code: smsCode,
    },
  });
}

export function getMyCouponData(params, silentRequest = false) {
  return request({
    url: '/My/coupons',
    params,
    silentRequest,
  });
}

export function getFaqData() {
  return request({
    url: '/Help/getFaqList',
  });
}

export function getFaqCategoryDetail(params, silentRequest = false) {
  return request({
    url: '/Help/getFaqCategory',
    params,
    silentRequest,
  });
}

export function submitFeedBack(content, contact) {
  return request({
    url: '/Help/feedback',
    method: 'POST',
    data: {
      content,
      contact,
    },
  });
}

export function getRemindData(path) {
  return request({
    url: '/My/remind',
    params: {
      redirectTo: path,
      avoidAlertMessage: 1,
    },
    toastMessage: false,
  });
}

export function getComingScheduleData(params, silentRequest = false) {
  return request({
    url: '/My/comingSchedule',
    params,
    silentRequest,
  });
}

export function getReplayScheduleData(params, silentRequest = false) {
  return request({
    url: '/My/replaySchedule',
    params,
    silentRequest,
  });
}

export function getReplayScheduleDetail(id) {
  return request({
    url: '/My/replayScheduleDetail',
    params: {
      id,
    },
  });
}

export function getMyCourseData(params, silentRequest = false) {
  return request({
    url: '/My/course',
    params,
    silentRequest,
  });
}

export function getMyInviteData() {
  return request({
    url: '/My/invite',
  });
}

export function getUserLoginWithToken() {
  return request({
    url: '/User/loginWithToken',
    method: 'POST',
    silentRequest: true,
  });
}

export function getUserLoginWithQueryToken(data) {
  return request({
    url: '/User/loginWithQueryToken',
    method: 'POST',
    data,
    silentRequest: true,
  });
}

export function getMyProjectData(params, silentRequest = false) {
  return request({
    url: '/My/project',
    params,
    silentRequest,
  });
}

export function getMyWorkData(params, silentRequest = false) {
  return request({
    url: '/My/work',
    params,
    silentRequest,
  });
}

export function getMyMedalData(params, silentRequest = false) {
  return request({
    url: '/My/medal',
    params,
    silentRequest,
  });
}

export function toggleMyCollect(targetType, targetId, collect) {
  return request({
    url: '/My/toggleCollect',
    method: 'POST',
    data: {
      targetType,
      targetId,
      collect,
    },
  });
}

export function getMyCollect(params, silentRequest = false) {
  return request({
    url: '/My/collect',
    params,
    silentRequest,
  });
}

export function getAgencyLoginPath(agency) {
  return request({
    url: '/User/getAgencyLoginPath',
    params: {
      agency,
    },
  });
}

export function getReadingInterest() {
  return request({
    url: '/My/readingInterest',
  });
}

export function readingInterestSubmit(idList) {
  return request({
    url: '/My/readingInterestSubmit',
    method: 'POST',
    data: {
      idList,
    },
  });
}

export function accountIsLock() {
  return request({
    url: '/User/accountIsLock',
  });
}

export function accountLockDetail(lockToken) {
  return request({
    url: '/User/lock',
    params: {
      lockToken,
    },
  });
}

export function getRequiredUserInfoPageStatus(action = '') {
  return request({
    url: '/MillionUser/requiredUserInfoPageStatus',
    params: {
      action,
    },
  });
}

export function getRequiredUserInfo(type) {
  return request({
    url: '/MillionUser/requiredUserInfo',
    params: {
      type,
    },
  });
}

export function submitRequiredInterests(interests) {
  return request({
    url: '/MillionUser/submitRequiredInterests',
    method: 'POST',
    data: {
      interests,
    },
  });
}

export function setGrade(id) {
  return request({
    url: '/MillionUser/setGrade',
    params: {
      gradeId: id,
    },
  });
}

export function getMillionReadArticleDetail(id) {
  return request({
    url: '/MillionArticle/detail',
    params: {
      id,
    },
  });
}

export function getReviewExplore(params) {
  return request({
    url: '/MillionArticle/reviewExplore',
    params,
  });
}

export function reviewLike(id, action) {
  return request({
    url: '/MillionArticle/reviewLike',
    method: 'POST',
    data: {
      id,
      action,
    },
  });
}

export function reviewCreate(replyId, content, articleId) {
  return request({
    url: '/MillionArticle/reviewCreate',
    method: 'POST',
    data: {
      replyId,
      content,
      articleId,
    },
  });
}

export function giftGetDetail(code) {
  return request({
    url: 'Gift/detail',
    params: {
      code,
    },
  });
}

export function getWeChatBindingStatus() {
  return request({
    url: '/User/hasBindWechat',
    method: 'POST',
  });
}

export function removeWeChatBinding() {
  return request({
    url: '/User/unBoundWechat',
    method: 'POST',
  });
}
